export default __webpack_public_path__ + "static/media/main_logoCon.01517608.png";